import { cn } from "@newxsystems/shared";
import { SproutAction } from "../SproutAction/SproutAction";
import { SproutMedia } from "../SproutMedia/SproutMedia";
import { SproutRichText } from "../SproutRichText/SproutRichText";
import type { IHeroBackgroundImageProps } from "./HeroBackgroundImage.props";

export const HeroBackgroundImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroBackgroundImageProps) => {
  const centered = alignment === "center";
  return (
    <div className="sprout-hero-art sprout-sky-lift relative flex min-h-[40rem] overflow-hidden rounded-[2.5rem_2.5rem_2.5rem_0.75rem] bg-charcoal-green-ink md:min-h-[48rem]">
      <SproutMedia
        className="absolute inset-0 h-full"
        imageClassName="object-cover"
        media={image.image}
        priority
        sizes="(min-width: 1536px) 1440px, calc(100vw - 48px)"
      />
      <div className="absolute inset-0 bg-charcoal-green-ink/10" />
      <div className="relative z-10 flex w-full items-end p-5 md:p-10 lg:p-14">
        <div
          className={cn(
            "sprout-workbook-paper sprout-chapter-tab sprout-paper-lift w-full max-w-[48rem] rounded-[1.5rem_1.5rem_1.5rem_0.35rem] border-2 border-navy-ink bg-whiteboard p-6 pt-9 text-navy-ink md:p-10 md:pt-12",
            centered && "mx-auto text-center",
          )}
        >
          <div className={cn("flex flex-col gap-5", centered && "items-center")}>
            {eyebrow ? (
              <p className="w-fit -rotate-1 rounded-lg bg-sunflower px-3 py-2 font-sprout-mono text-sm font-extrabold text-navy-ink">
                {eyebrow}
              </p>
            ) : null}
            {heading ? (
              <h1 className="font-sprout-display text-5xl font-bold leading-[0.96] tracking-[-0.03em] [overflow-wrap:anywhere] md:text-7xl lg:text-8xl">
                {heading}
              </h1>
            ) : null}
            {description ? (
              <SproutRichText className="max-w-[60ch] text-graphite" content={description} />
            ) : null}
            {buttons?.length ? (
              <div className={cn("flex flex-wrap gap-3 pt-2", centered && "justify-center")}>
                {buttons.map((button, index) => (
                  <SproutAction action={button} key={`${button.href}-${index}`} />
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

HeroBackgroundImage.displayName = "Content::HeroBackgroundImage";
